import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "govuk-width-container" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"govuk-phase-banner\"><p class=\"govuk-phase-banner__content\"><strong class=\"govuk-tag govuk-phase-banner__content__tag\"> beta </strong><span class=\"govuk-phase-banner__text\"> This is a new service – your <a href=\"mailto:HMCTSWills@ironmountain.co.uk?subject=Find a Will feedback\" target=\"_blank\" class=\"govuk-link\">feedback</a> will help us to improve it. </span></p></div>", 1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_4 = {
  class: "govuk-main-wrapper",
  id: "main-content",
  role: "main"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookieBanner = _resolveComponent("CookieBanner")!
  const _component_Header = _resolveComponent("Header")!
  const _component_Notice = _resolveComponent("Notice")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SuccessConfirmation = _resolveComponent("SuccessConfirmation")!
  const _component_ErrorSummary = _resolveComponent("ErrorSummary")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_CookieBanner),
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_Notice),
      (_ctx.showBackButton)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: { name: _ctx.backButtonRouteName, hash: '#page-heading-anchor' },
            class: "govuk-back-link"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true),
      _createElementVNode("main", _hoisted_4, [
        _createVNode(_component_SuccessConfirmation),
        _createVNode(_component_ErrorSummary),
        _createVNode(_component_router_view)
      ])
    ]),
    _createVNode(_component_Footer)
  ], 64))
}